import { render } from "./ShowApiError.vue?vue&type=template&id=79f56266"
import script from "./ShowApiError.vue?vue&type=script&lang=js"
export * from "./ShowApiError.vue?vue&type=script&lang=js"

import "./ShowApiError.vue?vue&type=style&index=0&id=79f56266&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__